module.exports = __webpack_public_path__ + "static/intro_stories_mobile-ed114a8a63b22812726b636013f99436.png";